var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "14px",
    viewBox: "0 0 23 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0C45E939-2157-4E5F-8222-B4398307E7E2@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 23 0 23 14 0 14"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Ongoing-casting",
    transform: "translate(-209.000000, -496.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-5",
    transform: "translate(209.000000, 496.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5607362,12.5805169 C21.4760736,12.6361829 21.2220859,12.7475149 20.9398773,12.5805169 L16.6503067,10.1033797 L16.6503067,3.84095427 L20.9116564,1.3359841 C21.193865,1.16898608 21.4478528,1.28031809 21.5322331,1.3359841 C21.6171779,1.3916501 21.8429448,1.55864811 21.8429448,1.86481113 L21.8711656,12.0516899 C21.8711656,12.3856859 21.6453988,12.5248509 21.5607362,12.5805169 L21.5607362,12.5805169 Z M15.5214724,11.8846918 C15.5214724,12.4413519 15.0699387,12.8866799 14.5055215,12.8866799 L2.14478528,12.8866799 C1.5803681,12.8866799 1.12883436,12.4413519 1.12883436,11.8846918 L1.12883436,2.14314115 C1.12883436,1.58648111 1.5803681,1.14115308 2.14478528,1.14115308 L14.5055215,1.14115308 C15.0699387,1.14115308 15.5214724,1.58648111 15.5214724,2.14314115 L15.5214724,11.8846918 Z M22.0687117,0.361829026 C21.5042945,0.055666004 20.8552147,0.055666004 20.3190184,0.389662028 L16.6220859,2.53280318 L16.6220859,2.11530815 C16.6220859,0.946322068 15.6625767,0 14.4770184,0 L2.14478528,0 C0.959509202,0 0,0.946322068 0,2.11530815 L0,11.8846918 C0,13.0536779 0.959509202,14 2.14478528,14 L14.5055215,14 C15.6907975,14 16.6503067,13.0536779 16.6503067,11.8846918 L16.6503067,11.3836978 L20.3754601,13.526839 C20.6576687,13.693837 20.967816,13.777336 21.2500245,13.777336 C21.5607362,13.777336 21.8429448,13.693837 22.1251534,13.554672 C22.6895706,13.2485089 23,12.6918489 23,12.0516899 L22.9717791,1.86481113 C22.9717791,1.25248509 22.6331288,0.69582505 22.0687117,0.361829026 L22.0687117,0.361829026 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBlank);
export default __webpack_public_path__ + "static/media/cameraBlank.6662a1b984aa6459127efe396285f175.svg";
export { ForwardRef as ReactComponent };